import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import { sendMessage } from '../helpers'

import { SOCKET_ON_MESSAGE, SOCKET_ACTION_TYPE } from '../constants'

import { entitySearchStart } from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/SearchContent/actions'
import { parseSearch } from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/SearchContent/helpers'
import {
    ENTITY_SEARCH_START,
    SOCKET_ENTITY_SEARCH_START,
} from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/SearchContent/constants'

function* onMessageFromOld(_action) {
    const type = _.get(_action, 'data.type', null)
    const searchValue = _.get(_action, 'data.content.searchValue', {})

    if (type === ENTITY_SEARCH_START && searchValue) {
        yield put(entitySearchStart(searchValue))
    }

    return null
}

function* wsSearchResultsCallSaga(_action) {
    const { searchValue } = _.get(_action, 'data', {})

    if (parseSearch(searchValue)) {
        yield sendMessage(SOCKET_ACTION_TYPE.SOCKET_SEARCH_RESULTS, {
            type: SOCKET_ACTION_TYPE.SOCKET_SEARCH_RESULTS,
            searchValue,
        })
    }

    return null
}

export default function* searchResultsSaga() {
    yield all([
        takeEvery(SOCKET_ON_MESSAGE, onMessageFromOld),
        takeEvery(SOCKET_ENTITY_SEARCH_START, wsSearchResultsCallSaga),
    ])
}
